import { Button } from "shared/ui/button";
import { formatDateForEvent } from "shared/lib/hooks/useDateFormatting";
import Share from "../../../assets/Share.svg";
import { useMobile } from "shared/lib/hooks";
import styles from "./EventCard.module.scss";

export const EventCard = ({ event, onDeleteClick, onQrCodeClick }) => {
  const isMobile = useMobile("420px");

  const imageSrc = event?.image || null;
  const imageUrl = imageSrc ? `data:image/png;base64,${imageSrc}` : null;
  return (
    <div className={styles.cardWrapper}>
      {imageUrl ? (
        <img
          className={styles.cardWrapper__img}
          src={imageUrl}
          alt={event?.header || "Мероприятие"}
        />
      ) : (
        <div className={styles.cardWrapper__imgPlaceholder}>
          Нет изображения
        </div>
      )}
      <div className={styles.cardWrapper__text}>
        <p className={styles.cardWrapper__title}>
          {event?.header ?? "Без названия"}
        </p>
        <p className={styles.cardWrapper__date}>
          {formatDateForEvent(event?.plannedDate)}
        </p>
      </div>
      <div className={styles.cardWrapper__buttons}>
        <div className={styles.cardWrapper__btn}>
          <Button variant="primary" size="large" onClick={onQrCodeClick}>
            Билет
          </Button>
        </div>
        <div className={styles.cardWrapper__btn}>
          <Button variant="outlineGreen" size="large" onClick={onDeleteClick}>
            {isMobile ? "Отменить" : "Отменить запись"}
          </Button>
        </div>
        <div className={styles.cardWrapper__shareBtn}>
          <Button
            variant="ghost"
            size="small"
            onClick={() => {
              if (event?.eventLink) {
                window.open(event.eventLink, "_blank", "noopener,noreferrer");
              }
            }}
            leftIcon={<img src={Share} alt="Share" height={28} width={28} />}
          />
        </div>
      </div>
    </div>
  );
};
